import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router-dom'
import T from 'i18n-react';
import './documents.css';
import DocumentIconButton from './documentIconButton';

const Documents = () => {
    const history = useHistory();

    const { lang, layoutType } = useSelector(state => state.layout, shallowEqual)
    const { linkConfig } = useSelector(state => state.config.linkConfig, shallowEqual)
    const taxYears = useSelector(state => state.workflow && state.workflow.case_state && state.workflow.case_state.taxYears
        ? state.workflow.case_state.taxYears : [], shallowEqual)

    const [checklistLink, setChecklistLink] = useState(null)

    useEffect(() => {
        let cll = null
        if (linkConfig && lang && linkConfig[lang]) {
            cll = linkConfig[lang]['checklist_link']
        }
        if (!cll) {
            cll = T.translate('Documents.ChecklistLink')
        }
        if (cll !== checklistLink) {
            setChecklistLink(cll)
        }
    }, [lang, setChecklistLink, checklistLink, linkConfig])

    const handleUpload = (taxYear, ticketType) => {
        let comingFrom = 'documents';
        history.push(`/dashboard/uploader/${taxYear}/${comingFrom}`)
    }

    const handleView = () => {
        history.push('/dashboard/documents')
    }

    return (
        <div className='documentsContainerWF'>
            <div className="documentsRootStyle">
                <div>
                    <div className='documents-header'>{T.translate('Documents.Title')}</div>
                    <div className='documents-subcontainer'>
                        <div className='documents-subheader'>{T.translate('Documents.UploadSubTitle')}</div>
                        <div className='documents-desc'>{T.translate('Documents.UploadDesc')}</div>
                        {taxYears.map(x =>
                            <DocumentIconButton key={'upload_' + x.taxYear} iconKey='Upload'
                                label='Documents.UploadButtonLabel' layoutType={layoutType}
                                labelContext={{ TaxYear: x.taxYear }}
                                onClick={(ev) => handleUpload(x.taxYear, x.ticket_type)} />
                        )}
                        <div className='documents-subheader'>{T.translate('Documents.SubTitle')}</div>
                        <div className='documents-desc'>{T.translate('Documents.ManageDesc')}</div>
                        <DocumentIconButton iconKey='Manage'
                            label="Documents.ViewButtonLabel" layoutType={layoutType}
                            onClick={handleView} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Documents

